import { render, staticRenderFns } from "./ProjectWbs.vue?vue&type=template&id=233816b4&scoped=true"
import script from "./ProjectWbs.vue?vue&type=script&lang=js"
export * from "./ProjectWbs.vue?vue&type=script&lang=js"
import style0 from "./ProjectWbs.vue?vue&type=style&index=0&id=233816b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233816b4",
  null
  
)

export default component.exports